/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import { createSelector } from 'reselect';

/**
 * Select all institutions available in the Redux store.
 *
 * @param state the Redux state
 * @returns array of institution objects, never {@code null} or {@code undefined}.
 */
const institutionsSelector = state => state.entities.institutions.byId;

/**
 * Select the context institution from the Redux store.
 *
 * @param state the Redux state.
 * @returns the context institution id or {null} if not set.
 */
export const getContextInstitutionId = state => state.entities.institutions.contextInstitution;

/**
 * Return all the institutions available in the redux store, sorted by their name.
 */
export const getInstitutionsSortedByName = createSelector(
  institutionsSelector,
  (institutionsById) => {
    return Object.values(institutionsById).sort((a, b) => a.name.localeCompare(b.name));
  }
);

/**
 * Returns the context institution from the redux store.
 */
export const getContextInstitution = createSelector(
  [institutionsSelector, getContextInstitutionId],
  (byId, contextInstitutionId) => {
    return byId && contextInstitutionId ? byId[contextInstitutionId] : null;
  }
);

/**
 * Returns IDs for all institutions the current user is authorized to access.
 * @param state
 * @return {Array}
 */
const authorizedInstitutionsSelector = state => {
  return (state && state.entities && state.entities.institutions && state.entities.institutions.authorized) || [];
};

/**
 * Return all institutions the current user is authorized to access.
 */
export const getAuthorizedInstitutions = createSelector([authorizedInstitutionsSelector, institutionsSelector],
  (ids, byId) => {
    return ids.map((id) => {
      return byId[id];
    });
  });



// WEBPACK FOOTER //
// ./src/institutions/selectors.js